import * as React from 'react';
import { Panel } from 'react-bootstrap';
import LoginForm from './LoginForm';
import SignupForm from './SignupForm';
import { wrap, withT } from '../../../lib/wrappers';

interface Props {
  t: (key: string) => string;
}

const AuthForms = ({ t }: Props) => (
  <div>
    <Panel className="panel-coolclimate">
      <Panel.Heading>{t('Login')}</Panel.Heading>
      <Panel.Body>
        <LoginForm />
      </Panel.Body>
    </Panel>
    <Panel className="panel-coolclimate">
      <Panel.Heading>{t('Signup')}</Panel.Heading>
      <Panel.Body>
        <SignupForm />
      </Panel.Body>
    </Panel>
  </div>
);

export default wrap(
  withT('auth'),
  AuthForms
);
